import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum AdtHolidaysActionTypes {
    FETCH_HOLIDAYS = '[ADT Holidays] Fetch Holidays',
    LOAD_HOLIDAYS = '[ADT Holidays] Load Holidays',
    LOAD_SUCCESS_HOLIDAYS = '[ADT Holidays] Load Success Holidays',
    RESET = '[ADT Holidays] Reset Holidays',
}

/**
 * Fetch holidays
 */
export class FetchHolidaysAction implements Action {
    readonly type = AdtHolidaysActionTypes.FETCH_HOLIDAYS;

    constructor(public payload: {countryCode: COUNTRY_CODE}) { }
}

/**
 * Load success holidays
 */
export class LoadSuccessHolidaysAction implements Action {
    readonly type = AdtHolidaysActionTypes.LOAD_SUCCESS_HOLIDAYS;

    constructor(public payload: Date[]) { }
}


/**
 * Load holidays
 */
export class LoadHolidaysAction implements Action {
    readonly type = AdtHolidaysActionTypes.LOAD_HOLIDAYS;

    constructor(public payload: Date[]) { }
}

/**
 * Reset holidays
 */
export class AdtResetHolidaysAction implements Action {
    readonly type = AdtHolidaysActionTypes.RESET;

    constructor() { }
}

export type AdtHolidaysActions =
    | FetchHolidaysAction
    | LoadHolidaysAction
    | LoadSuccessHolidaysAction
    | AdtResetHolidaysAction;
